
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M20.6497 12.1778C20.6497 7.32414 16.6786 3.35297 11.8249 3.35297C8.38324 3.35297 5.3828 5.29443 3.97083 8.20662"></path><path d="M3.2648 3L3.97079 8.20665L9.26568 7.50066"></path><path d="M18.2317 18.2537C18.8123 17.6333 19.3021 16.9256 19.6789 16.149"></path><path d="M12.0454 21C13.0356 20.9761 13.986 20.7917 14.8703 20.4696"></path><path d="M5.52917 18.3464C6.21663 19.0479 7.02057 19.6366 7.90747 20.0796"></path><path d="M3 12.1778C3 13.0973 3.14296 13.9851 3.40682 14.8199"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiRevert",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
